import { createSlice, current } from '@reduxjs/toolkit';
import {
	getWaterSourceList,
	getWaterSource,
	addNewWaterSource,
	updateWaterSource,
	deleteWaterSource,
	checkWaterSourceExists,
} from './thunk';

export const initialState = {
	itemWaterSourceList: [],
	itemWaterSource: null,
	isWaterSourceLoading: false,
	isWaterSourceSuccess: false,
	dataWaterSource: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const WaterSourceSlice = createSlice({
	name: 'WaterSource',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getWaterSourceList.pending, state => {
			state.isLoadingList = true;
			state.isWaterSourceSuccess = false;
		});

		builder.addCase(getWaterSourceList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemWaterSourceList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isWaterSourceSuccess = true;
		});

		builder.addCase(getWaterSourceList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isWaterSourceSuccess = false;
		});

		builder.addCase(getWaterSource.pending, state => {
			state.isWaterSourceLoading = true;
			state.isWaterSourceSuccess = false;
		});

		builder.addCase(getWaterSource.fulfilled, (state, action) => {
			state.itemWaterSource = action.payload;
			state.isWaterSourceLoading = false;
			state.isWaterSourceSuccess = true;
		});

		builder.addCase(getWaterSource.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isWaterSourceLoading = false;
			state.isWaterSourceSuccess = false;
		});

		builder.addCase(addNewWaterSource.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewWaterSource.fulfilled, (state, action) => {
			state.itemWaterSourceList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewWaterSource.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateWaterSource.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateWaterSource.fulfilled, (state, action) => {
			state.itemWaterSourceList = state.itemWaterSourceList.map(
				waterSourceList =>
					waterSourceList._id.toString() === action.payload._id.toString()
						? { ...waterSourceList, ...action.payload }
						: waterSourceList
			);
			state.statementList = state.statementList.map(waterSourceList =>
				waterSourceList._id.toString() === action.payload._id.toString()
					? { ...waterSourceList, ...action.payload }
					: waterSourceList
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateWaterSource.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteWaterSource.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteWaterSource.fulfilled, (state, action) => {
			state.itemWaterSourceList = current(state.itemWaterSourceList).filter(
				item => item._id !== action.payload._id
			);
			state.statementList = current(state.statementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteWaterSource.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkWaterSourceExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkWaterSourceExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkWaterSourceExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = WaterSourceSlice.actions;

export default WaterSourceSlice.reducer;
